module.exports = __webpack_public_path__ + "img/bms-gestao-icon.e75f2e24.png";